export const DOCUMENT_CONTEXT_MENU_TEXTS = {
  OPEN_DOCUMENT_NEW_TAB: 'Open Document in New Tab',
  OPEN_DOCUMENT_NEW_WINDOW: 'Open Document in New Window'
};
